export class GlobalDataController {

  static _isHomePage(): boolean {
    const homePage = /\/?home/i;
    const pathname = window.location.pathname;
    return homePage.test(pathname);
  }

  static getEnvironment(): string {
    const hostname = window.location.hostname;
    return /^.*\.stage\.aa\.com$/.test(hostname) ? 'stage' :
      /^.*\.qa\.aa\.com$/.test(hostname) || hostname === 'localhost' ? 'qa' : 'prod';
  }
}
